import { createFileRoute } from "@tanstack/react-router";
import IndexVariantB from "@/pages/IndexVariantB";
import { brand } from "@/data/site/brand";

export const Route = createFileRoute("/p/get-help")({
  // Paid-media landing page — never index. Canonical still points at the
  // primary production domain so any stray crawl/share attributes correctly.
  head: () => ({
    meta: [
      { title: "Get IRS Help Today — Free Case Review | Comprehensive Tax Resolution" },
      { name: "robots", content: "noindex, nofollow, noarchive, nosnippet, noimageindex" },
      { name: "googlebot", content: "noindex, nofollow" },
    ],
    links: [
      { rel: "canonical", href: `${brand.siteUrl.replace(/\/$/, "")}/p/get-help` },
    ],
  }),
  component: () => <IndexVariantB />,
});
